import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";
import ImageSlider from "./ImageSlider";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const images = [
    { url: "/images/P51800054847.PNG", caption: "P51800054847" },
    { url: "/images/P51800054846.PNG", caption: "P51800054846" },
    { url: "/images/P51800054828.PNG", caption: "P51800054828" },
    { url: "/images/P51800066457.PNG", caption: "P51800066457" },
    { url: "/images/P51800078863.PNG", caption: "P51800078863" },
    { url: "/images/P51800078922.PNG", caption: "P51800078922" },
  ];
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/rr-logo.jpg"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Raymond Realty
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Raymond Realty, the real estate arm of the iconic Raymond Group, brings
        nearly a century of trust and excellence into the world of urban
        development. From delivering landmark projects like Ten X Habitat to
        creating serene havens like The Address by GS Bandra, Raymond Realty
        stands for transparency, timely delivery, and world-class quality.
        <br />
        With a strong focus on customer-first design and future-ready
        infrastructure, the brand is committed to redefining luxury across
        Mumbai and Thane with projects that reflect aesthetic brilliance and
        long-term value.
      </p>
      {/* <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/P51800054847.PNG" alt="rera qr" />
          <strong>P51800054847</strong>
        </div>
        <div className="rera-item">
          <img src="images/P51800054846.PNG" alt="rera qr" />
          <strong>P51800054846</strong>
        </div>
        <div className="rera-item">
          <img src="images/P51800054828.PNG" alt="rera qr" />
          <strong>P51800054828</strong>
        </div>
        <div className="rera-item">
          <img src="images/P51800066457.PNG" alt="rera qr" />
          <strong>P51800066457</strong>
        </div>
        <div className="rera-item">
          <img src="images/P51800078863.PNG" alt="rera qr" />
          <strong>P51800078863</strong>
        </div>
        <div className="rera-item">
          <img src="images/P51800078922.PNG" alt="rera qr" />
          <strong>P51800078922</strong>
        </div>
      </div> */}
      <ImageSlider images={images} />

      {/* <span className="pro-rera text-center-mob">
        {project} has been registered via Karnataka RERA registration number and
        is available on the website{" "}
        <a href="https://rera.karnataka.gov.in/">
          https://rera.karnataka.gov.in/
        </a>{" "}
        under registered projects.
      </span> */}

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
